<template>
  <div style="position:relative" v-bind="$attrs">
    <LocationPicker v-if="lngLat" class="map-picker" v-model="editLocation" @change-marker="syncLocation">
    </LocationPicker>
    <div v-if="!isManual" class="form-group">
      <div v-if="selectCountry">
        <label v-if="labels" for="select-country" class="el-form-item__label">Pays</label>
        <el-select id="select-country" v-model="country" class="city-select" @change="updateModelValue('code_country', $event)" placeholder="Pays" style="z-index: 9; max-width:100%;" :teleported="false" filterable>
          <el-option
              v-for="(value, key) in countryList"
              :key="key"
              :label="value"
              :value="key">
          </el-option>
        </el-select>
      </div>
      <label v-if="typeof label === 'string'" for="autocomplete">
        {{ $t(label) }}
      </label>
      <input v-if="!isManual" v-model="citySearch" :class="inputClass" :placeholder="$t(placeholder)" type="text" @focusin="suggestionsFocus = true" @focusout="onFocusOut" v-click-outside="looseFocus" @input="suggestionsFocus = true" :disabled="disabled">
      <ul class="custom_autocomplete" v-show="showSuggestion">
        <li v-for="suggestion in suggestionsLoaded" class="item clickable-item" @click.prevent="selectSuggestion(suggestion)">
          <a href="" class="clickable-item">{{ suggestion.place_name }}</a>
        </li>
      </ul>
      <div v-if="hasCitySearchError" class="form-error-text">
        L'adresse n'est pas valide
      </div>
      <a v-if="manualMode && !isManual && !hideManualLink" class="info-link-underline" href="#" @click="activeManualMode">Ajouter l'adresse manuellement</a>
    </div>
  </div>
  <AddressForm
      v-if="isManual"
      :fields="manualFields"
      :formItemClass="formItemClass"
      :size="size"
      :formErrors="formErrors"
      :prefixErrorKey="prefixErrorKey"
      :modelValue="edit"
      @update:model-value="updateManualAddressValue"
      @changeField="onChangeField"
      :removeManualModeBtn="removeManualModeBtn"
      @changeAddress="manualChange"
      :suggestionMode="true"
      @changeMode="activeSuggestionMode"
  >
  </AddressForm>
</template>

<script>
import { citySuggestions, extractMapBoxAddress, getCountryCode, reverseGeocoding } from '../../services/geocoding.js'
import AddressForm from "./AddressForm.vue";
import LocationPicker from "~/modules/auth/components/LocationPicker.vue";

const defaultAddressType = {
  adresse: '',
  departement: '',
  region: '',
  lat: null,
  lng: null,
  location: '',
  numero: '',
  rue: '',
  codePostal: '',
  ville: '',
  pays: '',
  code_country: ''
}

export default {
  name: "inputCity",
  emits: ['update:modelValue', 'changeMode', 'isValid', "changeField"],
  components: {
    AddressForm,
    LocationPicker
  },
  props: {
    hideManualLink: {
      type: Boolean,
      default: false
    },
    manualFields: {
      type: Array,
      default () {
        return ['adresse', 'codePostal', 'ville', 'code_country']
      }
    },
    isManualDefault: {
      type: Boolean,
      default: false
    },
    prefixErrorKey: {
      type: String,
      default: ''
    },
    formItemClass: {
      type: String,
      default: 'old-ui'
    },
    formErrors: {
      type: Object,
      default () {
        return {}
      }
    },
    labels: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 5
    },
    selectCountry: {
      type: Boolean,
      default: false
    },
    removeManualModeBtn: {
      type: Boolean,
      default: false
    },
    label: {
      type: [Boolean, String],
      default: false
    },
    placeholder: {
      default () {
        return 'home.input.2'
      }
    },
    size: {
      type: String,
      default: 'large'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    manualMode: {
      type: Boolean,
      default: false
    },
    lngLat: {
      type: Boolean,
      default: false
    },
    updateLocation: {
      type: Boolean,
      default: false
    },
    modelValue: Object
  },
  data () {
    return {
      location: [],
      edit: defaultAddressType,
      // country: null,
      isManual: false,
      citySearch: '',
      selectedPosition: '',
      suggestionsFocus: false,
      suggestionsLoaded: [],
    }
  },
  mounted () {
    if (this.isManualDefault) {
      this.isManual = true
    }
  },
  watch: {
    'location': {
      deep: true,
      immediate: true,
      handler (val) {
        if (this.modelValue && !this.modelValue.numero && !this.modelValue.rue && !this.modelValue.codePostal && !this.modelValue.ville) {
          this.syncLocation(val)
        }
      }
    },
    modelValue: {
      immediate: true,
      deep: true,
      handler (val, oldVal) {
        if (val) {
          this.edit = JSON.parse(JSON.stringify({ ...this.edit, ...val }))
        }
        if (val && val.numero && val.rue && val.codePostal && val.ville) {
          this.citySearch = `${val.numero} ${val.rue}, ${val.codePostal} ${val.ville}, ${val.pays}`
        } else if (val && val.adresse && val.codePostal && val.ville && val.pays) {
          this.citySearch = `${val.adresse}, ${val.codePostal} ${val.ville}, ${val.pays}`
        } else {
          this.citySearch = ''
        }
        // console.log('watch modelValue')
        // console.log(val)
        // if (this.selectCountry && val && !val.code_country && val.pays) {
        //   this.getCountryCode(val)
        // }
        // if (this.updateLocation) {
        //   console.log('update location')
        //   console.log(val)
        //   if (val && val.lng && val.lat) {
        //     this.location = [val.lng, val.lat]
        //   } else {
        //     this.location = []
        //   }
        // }
      }
    },
    citySearch: {
      handler (val) {
        if (val.length > 1) {
          this.searchCityName(val)
        }
      }
    }
  },
  computed: {
    inputClass () {
      let classes = 'form-control'
      if (this.hasCitySearchError) {
        classes += ' form-item-input-error'
      }
      return classes
    },
    hasCitySearchError () {
      const manualFields = this.manualFields.map((field) => {
        return this.prefixErrorKey.length ? this.prefixErrorKey + '.' + field : field
      })
      return Object.keys(this.formErrors).filter((key) => {
        return manualFields.includes(key)
      }).length
    },
    editLocation () {
      if (this.edit.lat && this.edit.lng) {
        return [this.edit.lng, this.edit.lat]
      } else {
        return []
      }
    },
    country: {
      set (val) {
        console.log(this.modelValue)
        let newVal = JSON.parse(JSON.stringify({ ...this.modelValue, code_country: val }))
        console.log('set country')
        console.log(newVal)
        this.$emit('update:modelValue', newVal)
      },
      get () {
        return this.modelValue && this.modelValue.code_country ? this.modelValue.code_country : 'FR'
      }
    },
    isValid () {
      if (this.modelValue) {
        if (this.modelValue && this.modelValue.code_country && this.modelValue.code_country === 'FR') {
          const errors = []
          // is code postal valid include corsica and outremer
          const validPostalCode = this.modelValue.codePostal.match(/^(?:[0-8]\d|9[0-8])\d{3}$/)
          if (!validPostalCode) {
            errors.push('postalCode')
          }
          // const validPostalCode = this.modelValue.codePostal.match(/^[0-9]{5}$/)
          // is city valid
          const validCity = this.modelValue.ville.match(/^[a-zA-Z\s\-]+$/)
          if (!validCity) {
            errors.push('city')
          }
          // is street valid
          const validStreet = this.modelValue.rue.match(/^[0-9a-zA-Z\s\-]+$/)
          if (!validStreet) {
            errors.push('street')
          }
          // is street number valid
          const validStreetNumber = this.modelValue.numero.match(/^[0-9]+$/)
          if (!validStreetNumber) {
            errors.push('streetNumber')
          }
          const isValid = !(validPostalCode && validCity && validStreet && validStreetNumber)
          this.$emit('isValid', isValid, errors)
          return isValid
        } else {
          const errors = []
          const validCity = this.modelValue.ville.match(/^[a-zA-Z\s\-]+$/)
          if (!validCity) {
            errors.push('city')
          }
          const validStreet = this.modelValue.rue.match(/^[0-9]+[a-zA-Z\s\-]+$/)
          if (!validStreet) {
            errors.push('street')
          }
          const validStreetNumber = this.modelValue.numero.match(/^[0-9]+$/)
          if (!validStreetNumber) {
            errors.push('streetNumber')
          }
          const country = this.country !== null
          if (!country) {
            errors.push('country')
          }
          const isValid = !(validCity && validStreet && validStreetNumber && country)
          this.$emit('isValid', isValid, errors)
          return isValid
        }
      } else {
        this.$emit('isValid', false, ['all'])
        return false
      }
    },
    countryList () {
      return JSON.parse('{"AF":"Afghanistan","AX":"\u00c5land Islands","AL":"Albania","DZ":"Algeria","AS":"American Samoa","AD":"Andorra","AO":"Angola","AI":"Anguilla","AQ":"Antarctica","AG":"Antigua and Barbuda","AR":"Argentina","AM":"Armenia","AW":"Aruba","AU":"Australia","AT":"Austria","AZ":"Azerbaijan","BS":"Bahamas","BH":"Bahrain","BD":"Bangladesh","BB":"Barbados","BY":"Belarus","BE":"Belgium","BZ":"Belize","BJ":"Benin","BM":"Bermuda","BT":"Bhutan","BO":"Bolivia","BQ":"Bonaire, Sint Eustatius and Saba","BA":"Bosnia and Herzegovina","BW":"Botswana","BV":"Bouvet Island","BR":"Brazil","IO":"British Indian Ocean Territory","BN":"Brunei Darussalam","BG":"Bulgaria","BF":"Burkina Faso","BI":"Burundi","KH":"Cambodia","CM":"Cameroon","CA":"Canada","CV":"Cape Verde","KY":"Cayman Islands","CF":"Central African Republic","TD":"Chad","CL":"Chile","CN":"China","CX":"Christmas Island","CC":"Cocos (Keeling) Islands","CO":"Colombia","KM":"Comoros","CG":"Congo","CD":"Congo, The Democratic Republic of The","CK":"Cook Islands","CR":"Costa Rica","CI":"C\u00f4te d\u0027Ivoire","HR":"Croatia","CU":"Cuba","CW":"Cura\u00e7ao","CY":"Cyprus","CZ":"Czech Republic","DK":"Denmark","DJ":"Djibouti","DM":"Dominica","DO":"Dominican Republic","EC":"Ecuador","EG":"Egypt","SV":"El Salvador","GQ":"Equatorial Guinea","ER":"Eritrea","EE":"Estonia","ET":"Ethiopia","FK":"Falkland Islands (Malvinas)","FO":"Faroe Islands","FJ":"Fiji","FI":"Finland","FR":"France","GF":"French Guiana","PF":"French Polynesia","TF":"French Southern Territories","GA":"Gabon","GM":"Gambia","GE":"Georgia","DE":"Germany","GH":"Ghana","GI":"Gibraltar","GR":"Greece","GL":"Greenland","GD":"Grenada","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GG":"Guernsey","GN":"Guinea","GW":"Guinea-Bissau","GY":"Guyana","HT":"Haiti","HM":"Heard Island and McDonald Islands","VA":"Holy See (Vatican City State)","HN":"Honduras","HK":"Hong Kong","HU":"Hungary","IS":"Iceland","IN":"India","ID":"Indonesia","IR":"Iran, Islamic Republic of","IQ":"Iraq","IE":"Ireland","IM":"Isle of Man","IL":"Israel","IT":"Italy","JM":"Jamaica","JP":"Japan","JE":"Jersey","JO":"Jordan","KZ":"Kazakhstan","KE":"Kenya","KI":"Kiribati","KP":"Korea, Democratic People\u0027s Republic of","KR":"Korea, Republic of","KW":"Kuwait","KG":"Kyrgyzstan","LA":"Lao People\u0027s Democratic Republic","LV":"Latvia","LB":"Lebanon","LS":"Lesotho","LR":"Liberia","LY":"Libya","LI":"Liechtenstein","LT":"Lithuania","LU":"Luxembourg","MO":"Macao","MK":"Macedonia, The Former Yugoslav Republic of","MG":"Madagascar","MW":"Malawi","MY":"Malaysia","MV":"Maldives","ML":"Mali","MT":"Malta","MH":"Marshall Islands","MQ":"Martinique","MR":"Mauritania","MU":"Mauritius","YT":"Mayotte","MX":"Mexico","FM":"Micronesia, Federated States of","MD":"Moldova, Republic of","MC":"Monaco","MN":"Mongolia","ME":"Montenegro","MS":"Montserrat","MA":"Morocco","MZ":"Mozambique","MM":"Myanmar","NA":"Namibia","NR":"Nauru","NP":"Nepal","NL":"Netherlands","NC":"New Caledonia","NZ":"New Zealand","NI":"Nicaragua","NE":"Niger","NG":"Nigeria","NU":"Niue","NF":"Norfolk Island","MP":"Northern Mariana Islands","NO":"Norway","OM":"Oman","PK":"Pakistan","PW":"Palau","PS":"Palestine, State of","PA":"Panama","PG":"Papua New Guinea","PY":"Paraguay","PE":"Peru","PH":"Philippines","PN":"Pitcairn","PL":"Poland","PT":"Portugal","PR":"Puerto Rico","QA":"Qatar","RE":"R\u00e9union","RO":"Romania","RU":"Russian Federation","RW":"Rwanda","BL":"Saint Barth\u00e9lemy","SH":"Saint Helena, Ascension and Tristan da Cunha","KN":"Saint Kitts and Nevis","LC":"Saint Lucia","MF":"Saint Martin (French part)","PM":"Saint Pierre and Miquelon","VC":"Saint Vincent and the Grenadines","WS":"Samoa","SM":"San Marino","ST":"Sao Tome and Principe","SA":"Saudi Arabia","SN":"Senegal","RS":"Serbia","SC":"Seychelles","SL":"Sierra Leone","SG":"Singapore","SX":"Sint Maarten (Dutch part)","SK":"Slovakia","SI":"Slovenia","SB":"Solomon Islands","SO":"Somalia","ZA":"South Africa","GS":"South Georgia and the South Sandwich Islands","SS":"South Sudan","ES":"Spain","LK":"Sri Lanka","SD":"Sudan","SR":"Suriname","SJ":"Svalbard and Jan Mayen","SZ":"Eswatini","SE":"Sweden","CH":"Switzerland","SY":"Syrian Arab Republic","TW":"Taiwan, Province of China","TJ":"Tajikistan","TZ":"Tanzania, United Republic of","TH":"Thailand","TL":"Timor-Leste","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinidad and Tobago","TN":"Tunisia","TR":"Turkey","TM":"Turkmenistan","TC":"Turks and Caicos Islands","TV":"Tuvalu","UG":"Uganda","UA":"Ukraine","AE":"United Arab Emirates","GB":"United Kingdom","US":"United States","UM":"United States Minor Outlying Islands","UY":"Uruguay","UZ":"Uzbekistan","VU":"Vanuatu","VE":"Venezuela, Bolivarian Republic of","VN":"Vietnam","VG":"Virgin Islands, British","VI":"Virgin Islands, U.S.","WF":"Wallis and Futuna","EH":"Western Sahara","YE":"Yemen","ZM":"Zambia","ZW":"Zimbabwe"}')
    },
    showSuggestion ()
    {
      return this.suggestionsLoaded.length && this.suggestionsFocus
    },
    suggestions ()
    {
      return this.suggestionsLoaded.map((suggestion) => {
        const result = suggestion.place_name.split(', ')
        return {
          place: suggestion.place_name,
          position: suggestion.geometry.coordinates,
          city: result[0],
          region: result[1],
          country: result[2]
        }
      })
    },
    addressDetails () {
      return this.citySearch.match(/^([0-9]+)([a-zA-Z'\s\-]+),[\s]*([0-9]{4,5})\s([a-zA-Z'\s\-]+),\s([a-zA-Z\s\-]+)/)
    },
    hasStreetNumber () {
      return this.citySearch.match(/^[0-9]+/)
    }
  },
  methods: {
    onChangeField (field) {
      console.log('change field input city')
      console.log(field)
      console.log('field')
      this.$emit('changeField', field)
    },
    getKeyWithPrefix (field) {
      return this.prefixErrorKey.length ? this.prefixErrorKey + '.' + field : field
    },
    errorKey (field) {
      return this.formErrors[this.getKeyWithPrefix(field)]
    },
    updateModelValue (field, val) {
      this.edit[field] = val
      if (field === 'adresse') {
        this.edit.numero = null
        this.edit.rue = null
      }
      if (field === 'numero' || field === 'rue') {
        this.edit.adresse = `${this.edit.numero ? this.edit.numero + ' ' : ''}${this.edit.rue ? this.edit.rue : ''}`
      }
      if (field === 'code_country' && this.countryList[val]) {
        this.edit.pays = this.countryList[val]
      }
      console.log(JSON.parse(JSON.stringify(this.edit)))
      this.$emit('update:model-value', JSON.parse(JSON.stringify(this.edit)))
    },
    updateManualAddressValue (val) {
      console.log('updateManualAddressValue')
      this.edit = { ...this.edit, ...val }
      this.$emit('update:modelValue', JSON.parse(JSON.stringify(val)))
      if (this.lngLat) {
        this.updateStringLocation(val)
      }
      console.log(val)
    },
    async updateStringLocation (val) {
      let citySearch = false
      if (val && val.numero && val.rue && val.codePostal && val.ville) {
        citySearch = `${val.numero} ${val.rue}, ${val.codePostal} ${val.ville}, ${val.pays}`
      } else if (val && val.adresse && val.codePostal && val.ville && val.pays) {
        citySearch = `${val.adresse}, ${val.codePostal} ${val.ville}, ${val.pays}`
      }
      if (citySearch) {
        let search = await citySuggestions(citySearch, {
          types: 'address'
        })
        console.log('update string location')
        if (search.features.length) {
          let city = extractMapBoxAddress(search.features[0])
          let location = {
            lat: city.lat,
            lng: city.lng,
            location: city.location
          }
          this.edit = { ...this.edit, ...location }
        }

      } else {
        let location = {
          lat: null,
          lng: null,
          location: ''
        }
        this.edit = { ...this.edit, ...location }
      }
      this.$emit('update:modelValue', JSON.parse(JSON.stringify(this.edit)))
    },
    async syncLocation (val) {
      if (this.updateLocation && val && val.length === 2 && val[0] && val[1]) {
        console.log('sync location')
        console.log(val)

        const askAddress = await reverseGeocoding(val, {
          types: 'address'
        })
        const extracted = extractMapBoxAddress(askAddress.features[0])
        this.country = extracted.code_country
        this.$emit('update:modelValue', extracted)
        this.$emit('changeField', this.prefixErrorKey)
      }
    },
    async getCountryCode (val) {
      console.log('getCountryCode')
      console.log(val)
      this.country = await getCountryCode(val.pays)
      val.code_country = this.country
      this.$emit('update:modelValue', val)
      return this.country
    },
    onFocusOut () {
      setTimeout(() => {
        this.suggestionsFocus = false
      }, 200)
    },
    manualChange (event) {
      console.log('manual change')
      this.$emit('update:modelValue', event)
    },
    activeManualMode ($event) {
      if ($event) {
        $event.preventDefault()
      }
      // $event.preventDefault()
      this.isManual = true
      this.$emit('changeMode', this.isManual)
    },
    activeSuggestionMode () {
      this.isManual = false
      this.$emit('changeMode', this.isManual)
    },
    looseFocus() {
      this.suggestionsFocus = false
    },
    onFocus (ev) {
      // console.log('on focus')
      // console.log(ev)
    },
    selectSuggestion (choice) {
      console.log('choice')
      console.log(choice)
      const extracted = extractMapBoxAddress(choice)
      this.edit = { ...this.edit, ...extracted }
      this.edit.code_country = extracted.code_country
      console.log('extracted')
      console.log(extracted)
      this.$emit('update:modelValue', JSON.parse(JSON.stringify(extracted)))
      // this.country = extracted.code_country
      this.suggestionsFocus = false
    },
    async searchCityName (city)
    {
      const otherOptions = {}
      if (this.country) {
        otherOptions.country = this.country
      }
      if (this.limit) {
        otherOptions.limit = this.limit
      }
      citySuggestions(city, {
        types: 'address',
        ...otherOptions
      })
          .then(this.saveSuggestion)
          .catch(this.handleError)
    },
    handleError (e)
    {
      console.error(e)
    },
    saveSuggestion (data)
    {
      this.suggestionsLoaded = [...data.features]
    }
  }
}
</script>

<style lang="scss">
.map-picker {
  width: 100%;
  height: 200px;
  margin-bottom: 20px;
}
.custom_autocomplete {
  &:before {
    display: block;
    position: absolute;
    content: "";
    width: calc(100% + 2px);
    left: -1px;
    top: -10px;
    height: 10px;
    border: 1px solid #d5d5d5;
    border-top: none !important;
    background: white;
  }
  z-index: 2;
  margin-top: -10px;
  position: absolute;
  width: 100%;
  border-radius: 0 0 10px 10px;
  box-shadow: 0 10px 17px 0px rgb(0 0 0 / 10%);
  padding: 10px;
  border: 1px solid #d5d5d5;
  background: white;
  .item {
    list-style: none;
  }
  .clickable-item {
    cursor: pointer;
    & a {
      text-underline: none !important;
      text-decoration: none;
    }
    &:hover
    {
      & a {
        color: #fc2249;
      }
      color: #fc2249;
      background: #FFEDF0;
    }
    color: #080025;
    padding: 0;
    border-radius: 3px;
    transition: all 0.2s linear;
    margin: 0 !important;
    padding: 5px 10px;
    border: none !important;
    border-radius: 8px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>
